import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetConfig,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ResponsiveService } from '@x/common/responsive';
import { Observable, of } from 'rxjs';

/*
 * Notification is either a dialog or a bottom sheet, depending on screen size.
 * */

export interface INotificationComponent<C, R> {
  dialogRef?: MatDialogRef<C, R> | null;
  bottomSheetRef?: MatBottomSheetRef<C, R> | null;

  closeNotification(): void;
}

export interface INotificationConfig {
  component: ComponentType<any>;
  config?: MatDialogConfig & MatBottomSheetConfig;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private responsive: ResponsiveService,
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
  ) {}

  notification$<R>(config: INotificationConfig): Observable<R | undefined> {
    if (this.responsive.isBreakpoint({ min: 'MD' })) {
      return this.openDialog<R>(config);
    }

    return this.openBottomSheet<R>(config);
  }

  private openDialog<R>(notificationConfig: INotificationConfig) {
    const { component, config } = notificationConfig;
    if (!component) return of(undefined);

    return this.dialog
      .open<any, any, R>(component, { panelClass: 'rounded-corners', ...config })
      .afterClosed();
  }

  private openBottomSheet<R>(notificationConfig: INotificationConfig) {
    const { component, config } = notificationConfig;
    if (!component) return of(undefined);

    return this.bottomSheet
      .open<any, any, R>(component, { panelClass: 'rounded-corners-top', ...config })
      .afterDismissed();
  }
}
